<template>
  <v-container id="monitor-de-atividades" class="px-6">
      <v-row>
          <v-col class="pb-1 pt-0" cols="10">
            <h1>Monitor de atividades - {{monthYear}}
                <span>
                    <v-tooltip right >
                        <template v-slot:activator="{on, attrs}">
                            <v-btn 
                                color="primary" 
                                icon
                                small
                                @click=modalVideo()
                                v-bind="attrs"
                                v-on="on"  
                                >
                                <v-icon small>fa-regular fa-life-ring</v-icon>
                            </v-btn>
                        </template>
                        <span class="px-3 py-1 ma-0"
                            style="
                            border: solid 1px #999;
                            border-radius: 5px;
                            background-color: #fff;
                        ">Ajuda: Gerencie o envio do faturamento </span>
                    </v-tooltip>
                </span>
            </h1>
            <p>
                Gerencie o Envio do Faturamento (Cronograma) conforme a situação. <br>
                Eles estão agrupados conforme seus status, referente ao mês corrente
            </p>
          </v-col>
          <!-- <v-col class="text-right mt-0 px-8" cols="2">
            <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="pa-0">
                <v-progress-circular
                    :size="15"
                    :width="2"
                    color="primary"
                    indeterminate
                    class="pt-7 mr-3"
                ></v-progress-circular>
                <b>{{display}}</b>
                </span>
            </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                Atualizará em
                </span>
            </v-tooltip>
          </v-col> -->
          <v-col class="py-1" cols="12">
              <MonitorFilter
                :filter="(formData) => getList(formData)"
                :prestadores="prestadores"
                :operadoras="operadoras"
                :updateOperadoras="(id)=>getOperadorasList(id)"
              />
          </v-col>
          <v-col class="py-1" cols="12">
              <CardAtividades
                :list="monitorCronograma"
                :filter="(formData) => filterList(formData)"
                :parameters="parameters"
              />
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import MonitorFilter from './monitor_atividades/MonitorFilter'
import CardAtividades from './monitor_atividades/CardAtividades'
import moment from "moment"
moment.locale('pt-BR')
export default {
    components: {
        MonitorFilter,
        CardAtividades
    },
    data() {
        return {
            operadoras: [],
            prestadores: [],
            selected: {},
            monthYear: null,
            countDownTimer: null,
            display: '',
            parameters: null
        }
    },
    computed: {
        ...mapState({
            grupoEconomico: (state) => state.permissions.grupoEconomico,
            grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
            monitorCronograma: (state) => state.faturamento.monitorCronograma
        }),
    },
    beforeMount() {
        this.getParametrizacao()
    },
    mounted() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
        let opts = {
            grupoEconomico: this.grupoEconomico,
            modulo_operadora: "faturamento"
        };
        this.getOperadoras(opts).then(list=> {
            this.operadoras = list
        })
        this.monthYear = moment().format('MMMM')
        this.refreshTimer()
        this.startTimer(300)
    },
    methods: {
        ...mapActions({
            getOperadoras: "permissions/getOperadoras",
            getmonitorcronogramas: "faturamento/getmonitorcronogramas"
        }),
        getParametrizacao(){
            let opts = {
            query: [
                {
                Modulo: "Portal",
                Acao: "getparametrizacoes",
                Payload: {
                    grupo_economico: this.grupoEconomico,
                },
                },
            ],
            noLoader: true,
            };
            this.$store.dispatch("request/doRequest", opts).then(resp => this.parameters = resp.parametros)
        },
        modalVideo(){
      let paramModal = {
          codigo: "754272738",
          title: "Gerencie o envio do faturamento",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
        startTimer(duration) {
            let timer = duration, minutes, seconds
            this.countDownTimer = setInterval(() => {
                minutes = parseInt((timer / 60).toString(), 10)
                seconds = (timer % 60).toString(), 10
                minutes = minutes < 10 ? "00:0" + minutes : "00:" + minutes
                seconds = seconds < 10 ? "0" + seconds : seconds
                this.display = minutes + ":" + seconds
                if (--timer < 0) {
                    timer = duration
                    this.refreshTimer()
                }
            }, 1000);
        },
        refreshTimer () {
            if (this.$route.path != '/faturamento/monitordeatividades') {
                clearInterval(this.countDownTimer)
            } else {
               let payload = {
                    grupo_economico: this.grupoEconomico,
                    prestador_id: null,
                    operadora_ans_id: null
                }
                this.getmonitorcronogramas(payload)
            }
        },
        getList(formData) {
            let opts = {
                grupo_economico: this.grupoEconomico ,
                prestador_id: formData.prestador_id,
                operadora_ans_id: formData.operadora
            }
            this.getmonitorcronogramas(opts)
            this.selected = opts
        },
        filterList(val, blockUpdate) {
            let select = this.selected
            if (val == "sem-cronograma") {
                this.$router.push('/faturamento/lotessemcronograma')
            } else {
                let filter = {
                    prestador_id: select.prestador_id? select.prestador_id : null,
                    operadora_ans_id: select.operadora_ans_id? select.operadora_ans_id : null,
                    card_name: val,
                    owner_id: null
                }
                if(!blockUpdate){
                    this.$store.commit("faturamento/setFilter", filter, {root:true})
                }
                this.$router.push('/faturamento/cronogramas')
            }
        },
        getOperadorasList(prestador_id){
            let opts = {
                grupoEconomico: this.grupoEconomico,
                modulo_operadora: "faturamento",
                prestador_id
            };
            this.getOperadoras(opts).then(list => {
                this.operadoras = list
            })
        }
    }
}
</script>
